<template>

  <div>
    <input-keyword
      v-model="keywords"
      :placeholder="placeholder" />

    <creating
      v-if="loading"
      height="50px" />

    <div
      class="list-group"
      v-if="!loading">
      <div
        class="list-group-item list-group-item-primary"
        v-if="selectedJob">
        <div class="d-flex">
          <div class="pr-3">
            <input
              type="checkbox"
              :checked="selectedJob"
              @input="setJob(null)">
          </div>
          <div class="w-100">
            <point-status :status="selectedJob.status"></point-status> {{ selectedJob.title }} #{{ selectedJob.code }}<br>
            <small>{{ selectedJob.company_id.name }}, {{ selectedJob.departament_id.name }}</small>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="list-group-item list-group-item-action"
        v-for="(job, index) in jobs"
        :key="index"
        @click="setJob(job._id)">
        <point-status :status="job.status"></point-status> {{ job.title }} #{{ job.code }}<br>
        <small>{{ job.company_id.name }}, {{ job.departament_id.name }}</small>
        </button>
    </div>

  </div>

</template>

<script>
import InputKeyword from './InputKeyword'
import PointStatus from '@/components/Parts/PointStatus'

export default {
  name: 'SelectJob',
  components: {
    InputKeyword,
    PointStatus
  },
  props: {
    'value': {
      type: String,
      default: null
    },
    'disconsiderIds': {
      type: Array,
      default: () => {
        return []
      }
    },
    'filters': {
      type: Object,
      default: () => {
        return {}
      }
    },
    'placeholder': {
      type: String,
      default: function () {
        return this.$t('Find job')
      }
    },
    'limit': {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      loading: false,
      jobs: [],
      keywords: ''
    }
  },
  watch: {
    keywords: function (val, oldVal) {
      if (val) {
        this.searchData({title: '~' + val})
      } else {
        this.jobs = []
      }
    }
  },
  created () {
    if (this.value) {
      this.loadData(this.value)
    }
  },
  computed: {
    selectedJob () {
      return this.$store.getters['entities/jobs/find'](this.value)
    }
  },
  methods: {
    loadData (id) {
      this.loading = true

      this.$store
      .dispatch('getJobById', id)
      .then(result => {
        this.loading = false
      })
    },
    searchData (params) {
      this.loading = true

      params = {
        ...params,
        ...this.filters,
        'limit': this.limit,
        'sort': '-created_at'
      }

      if (this.disconsiderIds) {
        params['_id'] = this.disconsiderIds.map(v => `!${v}`)
      }

      this.$store
      .dispatch('getJobs', params)
      .then(result => {
        this.jobs = result.docs
        this.loading = false
      })
    },
    setJob (id) {
      this.$emit('input', id)
      this.keywords = ''
      this.jobs = []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectJob.vue